import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { PackageCreator } from './packageCreator';
import {
  ConnectionStrategy,
  ResponseMessage,
  BaseWSErrorMsg,
  SSHMessage,
  WebsocketSSHConnection
} from './robotConnection';

export enum CommandResponse {
  SUCCESS = 0,
  FAILURE = 1,
  SKIPPED = 2
}

export interface ProcessResponseArg {
  strategy: CommandListStrategy;
  response: string;
  extraInfo?: any;
}

export interface CommandObject {
  command: string;
  processResponse: (arg: ProcessResponseArg) => CommandResponse;
  extraInfo?: any;
}
export class CommandListStrategy implements ConnectionStrategy {
  currIndex = 0; // current index within the command list
  commandList: Array<CommandObject> = []; // list of commands to process
  robotPackages: Array<PackageT> = [];
  creationPackages: Array<PackageCreator> = [];
  whenFinished: () => void = () => {};
  // NOTE: pythonSSH creates new terminal for each command.
  // hence ros needs to be sourced each time
  setupString: string = '';
  /**
   * Function to be called to set the progress of the loading bar
   */
  loadProgressFunc: (text: string, value: number, close?: boolean) => void =
    () => {};

  constructor(sourceCommands: string) {
    this.setupString = sourceCommands;
  }
  /**
   * Processes the message response. Sends the next message in the command list.
   * if there are no more commands to give, generates the creation packages
   * @param connection
   * @param message
   */
  public processMessage(
    connection: WebsocketSSHConnection,
    message: ResponseMessage
  ): void {
    if (!message.error.isError) {
      this.loadProgressFunc('Getting data from robot', 10);
      this.commandList[this.currIndex].processResponse({
        strategy: this,
        response: message.payload.data as string,
        extraInfo: this.commandList[this.currIndex].extraInfo
      });
    } else {
      this.processErrorResponse(message.error);
    }
    this.currIndex++;
    if (this.currIndex >= this.commandList.length) {
      this.finishCreation();
    } else {
      connection.sendMessage({
        command: 'write',
        data: this.setupString + this.commandList[this.currIndex].command
      });
    }
  }

  getFirstMessage(): SSHMessage | null {
    return new SSHMessage(this.setupString + this.commandList[0].command);
  }

  setProgress(text: string): void {
    this.loadProgressFunc(
      text,
      Math.floor((this.currIndex / this.commandList.length) * 100)
    );
  }

  finishCreation(): void {
    this.whenFinished();
  }

  /**
   * Adds commands to the command list at given index.
   * if the index is left out instead adds them directly after the current index
   */
  addCommands(
    commands: Array<CommandObject>,
    index: number = this.currIndex + 1
  ): void {
    this.commandList.splice(index, 0, ...commands);
  }

  getCurrentCommand(): CommandObject | undefined {
    if (this.currIndex >= this.commandList.length) return;
    return this.commandList[this.currIndex];
  }

  processErrorResponse(error: BaseWSErrorMsg) {}
}
